@if (page) {
  <section
    id="basic-page"
    [style.background-color]="page.backgroundColor"
    [cropImage]="page.mediaImage | preSignedUrl | async"
    [additionalOptions]="{width: 1920}">
    @if (page.hasSlides) {
      @if (slideBuilderData) {
        <div
          class="slide-builder-container"
          [slideBackground]="slideBuilderData">
          <app-slide-builder
            [slideData]="slideBuilderData"
            [chapterContainerHeight]="containerHeight"
            (videoWatched)="videoWatched($event, false)">
          </app-slide-builder>
        </div>
      }
    } @else {
      <app-block-list [page]="page"></app-block-list>
    }
  </section>
}
